import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_list_item_group = _resolveComponent("v-list-item-group")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", null, "ログインする企業を選択", -1)),
    _createVNode(_component_v_list, { class: "mt-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_list_item_group, { color: "primary" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (company) => {
              return (_openBlock(), _createBlock(_component_v_card, {
                class: "my-2",
                outlined: "",
                key: company.companyId
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    onClick: ($event: any) => (_ctx.selectCompany(company))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(company.companyName), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}